import { render, staticRenderFns } from "./ManagerHoldingList.vue?vue&type=template&id=100b20ed&scoped=true"
import script from "./ManagerHoldingList.vue?vue&type=script&lang=js"
export * from "./ManagerHoldingList.vue?vue&type=script&lang=js"
import style0 from "./ManagerHoldingList.vue?vue&type=style&index=0&id=100b20ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100b20ed",
  null
  
)

export default component.exports